var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6625 3.81738H9.3375C7.96323 3.82709 6.64756 4.37527 5.67299 5.34424C4.69841 6.31321 4.14264 7.6257 4.125 8.99988V31.5674H26.6625C28.0471 31.5674 29.3757 31.0205 30.359 30.0456C31.3423 29.0708 31.9006 27.747 31.9125 26.3624V8.99988C31.8947 7.61923 31.3338 6.30115 30.3511 5.33113C29.3685 4.36112 28.0433 3.81727 26.6625 3.81738ZM24.66 25.4999C24.2918 25.5014 23.9315 25.3935 23.6246 25.1901C23.3177 24.9866 23.0782 24.6966 22.9362 24.3569C22.7943 24.0171 22.7564 23.6429 22.8273 23.2816C22.8982 22.9203 23.0748 22.5882 23.3346 22.3273C23.5945 22.0665 23.9259 21.8886 24.2869 21.8162C24.6479 21.7438 25.0222 21.7802 25.3625 21.9208C25.7029 22.0613 25.9938 22.2997 26.1985 22.6057C26.4032 22.9118 26.5125 23.2717 26.5125 23.6399C26.5135 23.8838 26.4663 24.1255 26.3736 24.3511C26.281 24.5767 26.1447 24.7818 25.9726 24.9546C25.8005 25.1275 25.5959 25.2646 25.3707 25.3582C25.1454 25.4517 24.9039 25.4999 24.66 25.4999Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.168 18C18.1625 18 19.1164 18.3951 19.8196 19.0983C20.5229 19.8016 20.918 20.7554 20.918 21.75C20.918 22.7446 20.5229 23.6984 19.8196 24.4017C19.1164 25.1049 18.1625 25.5 17.168 25.5H10.9805V10.5H17.168C18.1625 10.5 19.1164 10.8951 19.8196 11.5983C20.5229 12.3016 20.918 13.2554 20.918 14.25C20.918 15.2446 20.5229 16.1984 19.8196 16.9017C19.1164 17.6049 18.1625 18 17.168 18ZM17.168 18H10.9805",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingWhite);
export default __webpack_public_path__ + "static/media/booking_white.aade9a3f58b27eaed8b50a65112b268c.svg";
export { ForwardRef as ReactComponent };